// features/employee/fund/components/EmployeeFund.jsx
import { PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import EmployeeFundEmptyState from "./EmployeeFundEmptyState";
import EmployeeFundModal from "./EmployeeFundModal";
import EmployeeFundSummaryCard from "./EmployeeFundSummaryCard";
import EmployeeFundTable from "./EmployeeFundTable";
import styles from "../styles/EmployeeFund.module.css";

const { Title, Text } = Typography;

const EmployeeFund = ({
    membershipList = [],
    isLoading = false,
    pagination = {},
    summary,
    year,
    currentBuddhistYear,
    onYearChange = () => { },
    onChange = () => { },
    onAdd = () => { },
    onView = () => { },
    onEdit = () => { },
    onDelete = () => { },
    // modal
    modalOpen = false,
    modalMode = "create",
    form,
    fundOptions = [],
    isSaving = false,
    onModalOk = () => { },
    onModalCancel = () => { },
}) => {
    const { t } = useTranslation();
    const hasFunds = membershipList.length > 0;

    return (
        <Space direction="vertical" size={20} className={styles.container}>
            <Flex className={styles.headerRow}>
                <Flex vertical>
                    <Title level={4} style={{ margin: 0 }}>
                        {t("employeeFund.header") || "กองทุน"}
                    </Title>
                    <Text className={styles.subtitle}>
                        {t("employeeFund.subHeader") || "จัดการข้อมูลกองทุนสำรองเลี้ยงชีพและการสมทบของพนักงาน"}
                    </Text>
                </Flex>
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    {t("employeeFund.label.addFund") || "เพิ่มกองทุน"}
                </Button>
            </Flex>

            {hasFunds && (
                <>
                    <EmployeeFundSummaryCard
                        fundCount={membershipList.length}
                        summary={summary}
                        year={year}
                        currentBuddhistYear={currentBuddhistYear}
                        onYearChange={onYearChange}
                        asOfDate={summary?.asOfDate}
                    />

                    <EmployeeFundTable
                        dataSource={membershipList}
                        isLoading={isLoading}
                        pagination={pagination}
                        onChange={onChange}
                        onView={onView}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />

                    <div className={styles.footerNote}>
                        {t("employeeFund.label.footerNote") ||
                            'หมายเหตุ : หากต้องการเพิ่มพนักงานเข้ากองทุนอื่น กรุณากดปุ่ม "เพิ่มกองทุน" ด้านบน'}
                    </div>
                </>
            )}

            {!hasFunds && !isLoading && <EmployeeFundEmptyState onAdd={onAdd} />}

            <EmployeeFundModal
                open={modalOpen}
                mode={modalMode}
                form={form}
                fundOptions={fundOptions}
                isSaving={isSaving}
                onOk={onModalOk}
                onCancel={onModalCancel}
            />
        </Space>
    );
};

export default EmployeeFund;
